import { animate, state, style, transition, trigger } from '@angular/animations';
import { DOCUMENT, isPlatformBrowser, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, OnDestroy, OnInit, Output, PLATFORM_ID, inject } from '@angular/core';
import { environment } from "../../../../environments/environment";
import { TerritoryService } from "../../../services/geolocation/territory.service";
import { ImageManager } from "../../../shared/image-manager";
import {Territory} from "../../../shared/object/xplorer-be-parsed-classes";
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'xplorer-bowser-location-switch-popup',
    templateUrl: './location-switch-popup.component.html',
    styleUrls: ['./location-switch-popup.component.css'],
    animations: [
        trigger('bottomSheetAnimation', [
            state('open', style({ transform: 'translateY(0)', opacity: 1 })),
            state('closed', style({ transform: 'translateY(100%)', opacity: 0 })),
            transition('closed => open', animate('300ms ease-out')),
            transition('open => closed', animate('300ms ease-in'))
        ])
    ],
    imports: [NgClass, TranslateModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LocationSwitchPopupComponent implements OnInit, OnDestroy {

  isVisible: boolean = false;
  animationState: 'open' | 'closed' = 'closed';
  readonly availableTerritories: Territory[] = environment.AVAILABLE_TERRITORY;

  @Output() closeSheet = new EventEmitter<void>();

  private readonly territoryService: TerritoryService = inject(TerritoryService);
  private readonly document = inject(DOCUMENT);
  private readonly platformId = inject(PLATFORM_ID);
  private readonly isBrowser = isPlatformBrowser(this.platformId);
  private openTimeoutId?: ReturnType<typeof setTimeout>;
  private closeTimeoutId?: ReturnType<typeof setTimeout>;


  ngOnInit(): void {
    this.openTimeoutId = setTimeout(() => {
      this.isVisible = true;
      this.animationState = 'open';
    }, 50);
  }

  ngOnDestroy(): void {
    this.clearScheduledTransitions();
  }

  closeModal(): void {
    this.animationState = 'closed';
    this.clearTimeout(this.openTimeoutId);
    this.closeTimeoutId = setTimeout(() => {
      this.isVisible = false;
      this.closeSheet.emit();
    }, 300);
  }

  protected readonly ImageManager = ImageManager;

  getCurrentTerritoryCode() {
    return this.territoryService.getTerritoryCodeFromUrl();
  }

  changeTerritory(selectedTerritory: Territory) {
    if (selectedTerritory.code === this.getCurrentTerritoryCode()) {
      return;
    }

    if (environment.IS_LOCAL) {
      this.territoryService.setActiveTerritory(selectedTerritory.code);
      if (this.isBrowser) {
        this.document.location.reload();
      }
      return;
    }

    if (this.isBrowser) {
      this.document.location.href =
        environment.FRONTEND_BASE_URL.replace('://', '://' + selectedTerritory.code + '.');
    }
  }

  private clearScheduledTransitions(): void {
    this.clearTimeout(this.openTimeoutId);
    this.clearTimeout(this.closeTimeoutId);
  }

  private clearTimeout(timeoutId?: ReturnType<typeof setTimeout>): void {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
  }

}
